import { render, staticRenderFns } from "./Ellipsis.vue?vue&type=template&id=86347bb6"
import script from "./Ellipsis.vue?vue&type=script&lang=js"
export * from "./Ellipsis.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports